import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NotificationService } from 'src/backend/services/notification.service';
import { Constants } from 'src/@smartmanufacturing/common/constants';
import { AuthService } from 'src/backend/services/auth.service';

@Component({
  selector: 'app-private-layout',
  templateUrl: './private-layout.component.html',
  styleUrls: ['./private-layout.component.scss']
})
export class PrivateLayoutComponent implements OnInit {
  isMenuOpen = false;
  isMobMenuActive = false;
  islogin!: boolean;
  constructor(private router: Router, private authService: AuthService,
     private notificationService: NotificationService) { }

  ngOnInit(): void {
    this.islogin = this.loggedIn();
    if (!this.islogin) {
      this.router.navigate(['login']);
    }
    const filteredParams = {
      notificationType: '',
      pageIndex: 0,
      pageSize: Constants.PAGE_SIZE
    }
    this.notificationService.getUserNotifications(filteredParams);
  }

  onMenuTogglerChange(isMenuOpenStatus: boolean): void {
    this.isMenuOpen = isMenuOpenStatus ? false : true;
  }

  // sidebar menu change event function
  onMobMenuChange(isMobMenuOpenStatus: boolean): void {
    this.isMobMenuActive = isMobMenuOpenStatus ? false : true;
  }

  // close sidebar mobile menu layer
  closeMobMenu(): void {
    this.isMobMenuActive = !this.isMobMenuActive;
    this.isMenuOpen = false;
  }

  loggedIn(): any {
    return this.authService.isLoggedIn();
  }

}
